export default {
  invoice_book: [
    {
      required: true,
      message: 'Szamlatömb kiválasztása kötelező',
      trigger: 'change'
    }
  ],
  customer: [
    {
      required: true,
      message: 'Vevő kiválasztása kötelező',
      trigger: 'change'
    }
  ],
  customer_address: [
    {
      required: true,
      message: 'Vevő címének kiválasztása kötelező',
      trigger: 'change'
    }
  ],
  supplier: [
    {
      required: true,
      message: 'Eladó kiválasztása kötelező',
      trigger: 'change'
    }
  ],
  currency: [
    {
      required: true,
      validator: (rule, value, callback) => value && value.id ? callback() : callback(new Error('Deviza megadása kötelező')),
      trigger: 'change'
    }
  ],
  issue_date: [
    {
      required: true,
      message: 'Kiállítás dátuma kötelező',
      trigger: 'change'
    }
  ],
  delivery_date: [
    {
      required: true,
      message: 'Teljesítés dátuma kötelező',
      trigger: 'change'
    }
  ],
  payment_date: [
    {
      required: true,
      message: 'Fizetési határidő kötelező',
      trigger: 'change'
    }
  ],
  payment_method: [
    {
      required: true,
      message: 'Fizetési mód kötelező',
      trigger: 'change'
    }
  ],
};
